import type { ReactNode } from 'react'
import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react'

function ErrorFallback() {
  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <p>Something went wrong.</p>
      <button onClick={() => window.location.reload()}>Reload the page to try again.</button>
    </div>
  )
}

export function ErrorBoundary({ children }: { children: ReactNode }) {
  return (
    <SentryErrorBoundary fallback={<ErrorFallback />}>
      {children}
    </SentryErrorBoundary>
  )
}
